let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("hh76d")).then(() => parcelRequire('fFz2g'));